import React from 'react';
import IconWrapper from '../../../IconWrapper';
const BagIconMedium = (props) => (React.createElement(IconWrapper, { ...props },
    React.createElement("path", { fillRule: "evenodd", d: "M8 6V4.5C8 3.184 8.947 2 10.25 2h3.5C15.053 2 16 3.184 16 4.5V6h4v16H4V6h4Zm1-1.5c0-.893.62-1.5 1.25-1.5h3.5c.63 0 1.25.607 1.25 1.5V6H9V4.5ZM5 7h14v14H5V7Z" })));
export default BagIconMedium;
//# sourceMappingURL=BagIconMedium.js.map